<template>
    <div class="mx-3">
        <AlertDismiss ref="alertDismiss"></AlertDismiss>
        <b-breadcrumb>
            <b-breadcrumb-item v-for="crumb in breadcrumbs" :key="crumb.text" :active="crumb.to === null"
                :to="crumb.to">
                <span v-if="crumb.icon">
                    <b-icon :icon="crumb.icon" class="me-1"></b-icon>
                    <b>{{ crumb.text }}</b>
                </span>
                <span v-else>
                    {{ crumb.text }}
                </span>

            </b-breadcrumb-item>

        </b-breadcrumb>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';

export default {
    name: 'CourseBreadcrumb',

    components: {
        AlertDismiss,
    },

    data() {
        return {
            courseInfo: null,
        }
    },

    computed: {
        courseId() {
            return this.$route.params?.courseId;
        },

        breadcrumbs() {
            const crumbs = [{
                text: 'Cursos',
                to: '/Training',
                icon: 'folder'
            }]

            if (!this.courseInfo) {
                return crumbs;
            }

            crumbs.push({
                text: this.courseInfo.name,
                to: '/Training/' + this.courseId
            });

            return crumbs;
        }
    },

    methods: {
        ...mapActions(["getCourseById"]),

        async fetchCourseInfo() {
            const result = await this.getCourseById({ courseId: this.courseId })
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message, 'danger')
                return
            }

            this.courseInfo = result.data
        },
    },

    watch: {
        courseId: {
            immediate: true,
            handler() {
                this.courseInfo = null
                if (this.courseId) {
                    this.fetchCourseInfo()
                }
            }
        }
    }
}
</script>